import React, { useState, useEffect }from "react";
import { useAuth0 } from '@auth0/auth0-react';
import { Container, Grid, Image, Menu, Divider, Header } from "semantic-ui-react";

const Profile = () => {
  const { user, isAuthenticated, isLoading,  getAccessTokenSilently} = useAuth0();
  const [userMetadata, setUserMetadata] = useState(null);
  const [dbUser, setDbUser] = useState(null);
  const [activeTab, setActiveTab] = useState("profile");
  const namespace = "http://myapp.com//";
  const roles = isAuthenticated ? user[namespace + "roles"] || [] : [];
  
  // Connection to Auth0
  useEffect(() => {
    const getUserMetadata = async () => {
      const domain = "dev-8o8b478ko47aqil0.us.auth0.com";

      try {
        const accessToken = await getAccessTokenSilently({
          authorizationParams: {
            audience: `https://${domain}/api/v2/`,
            scope: "read:current_user",
          },
        });

        const userDetailsByIdUrl = `https://${domain}/api/v2/users/${user.sub}`;

        const metadataResponse = await fetch(userDetailsByIdUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        const { user_metadata } = await metadataResponse.json();

        setUserMetadata(user_metadata);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);
  
  //Connection to SQL Database fro specific user
  useEffect(() => {
    const loadOrCreateUser = async () => {
      if (!user || !isAuthenticated) return;

      const url = new URL("/go/api/v1/users/by-email-or-create", window.location.origin);
      url.searchParams.append("email", user.email);
      url.searchParams.append("first_name", user.given_name || "");
      url.searchParams.append("last_name", user.family_name || "");
      url.searchParams.append("gravatar", user.picture || "");

      try {
        const res = await fetch(url.toString());
        const data = await res.json();
        setDbUser(data);
      } catch (err) {
        console.error(err);
      }
    };

    loadOrCreateUser();
  }, [user, isAuthenticated]);
  


  if (isLoading || !dbUser) {
    return <div>Loading ...</div>;
  }

  const dbmetadata = dbUser.Meta || {}; //making sure metadata accessed is from the SQL

  // tabs for the history of the user and the such
  let content;
  switch (activeTab) {
    case "profile":
      content = (
        <div>
          <Header as="h3">Profile Information</Header>
          <p><strong>First Name:</strong> {dbUser.FirstName}</p>
          <p><strong>Last Name:</strong> {dbUser.LastName}</p>
          <p><strong>Email:</strong> {dbUser.Email}</p>
          <p><strong>Created At:</strong> {new Date(dbUser.CreatedAt).toLocaleString()}</p>
        </div>
      );
      break;
    case "collections":
      content = (
        <div>
          <Header as="h3">Collections</Header>
          <p>{JSON.stringify(dbmetadata.collections || {}, null, 2)}</p>
        </div>
      );
      break;
    case "history":
      content = (
        <div>
          <Header as="h3">Edit History</Header>
          <p>{JSON.stringify(dbmetadata.editHistory || {}, null, 2)}</p>
        </div>
      );
      break;
    default:
      content = null;
  }




  return (
    isAuthenticated && (
      <Container className="view-container">
        <Grid>
          <Grid.Column width={3}>
            <Image fluid src={dbUser.Gravatar} />
            <Menu text vertical fluid>
              <Menu.Item header>Profile Navigation</Menu.Item>
              <Menu.Item
                name="Profile Information"
                active={activeTab === "profile"}
                onClick={() => setActiveTab("profile")}
              />
              <Menu.Item
                name="Collections"
                active={activeTab === "collections"}
                onClick={() => setActiveTab("collections")}
              />
              <Menu.Item
                name="Edit History"
                active={activeTab === "history"}
                onClick={() => setActiveTab("history")}
              />
            </Menu>
          </Grid.Column>

          <Grid.Column width={13}>
            <div className="profile-header-bar">
              <Header as="h1" size="huge">
                {dbUser.FirstName} {dbUser.LastName}
              </Header>
            </div>
            <Divider hidden />
            {content}
          </Grid.Column>
        </Grid>
      </Container>
    )
  );
};



export default Profile;
